<div class="wrapper">
  <p *ngIf="config?.title" [class]="config?.titleClass">{{ config?.title | translate }}</p>
  <p *ngIf="config?.subtitle" class="{{ className }} {{ config?.subtitleClass }}">{{ config?.subtitle | translate }}</p>
</div>
